<template>
	<div
		class="flex h-10 items-center gap-2 rounded-full border-2 px-2 transition-all duration-500"
		:class="{
			'border-red snap-start bg-[#3F3F3F]': active,
			'bg-fill-tertiary border-transparent': !active
		}"
	>
		<div
			class="transition-all duration-500 *:h-7 *:w-7"
			:class="{ 'opacity-30 grayscale': !active, 'grayscale-0': active }"
		>
			<slot />
		</div>
		<div
			class="text-sm font-medium whitespace-nowrap capitalize transition-all duration-500"
			:class="{
				'text-label-primary': active,
				'text-label-tertiary': !active
			}"
		>
			{{ name }}
		</div>
		<AccentLabel :value="value" :active="active" />
	</div>
</template>
<script setup lang="ts">
import AccentLabel from './AccentLabel.vue'

defineProps<{
	name: string
	value: string
	active?: boolean
}>()
</script>
